<template>
  <el-card class="bottom-pad" shadow="hover">
    <el-row slot="header" type="flex" justify="space-between" align="middle">
      <el-row type="flex" align="middle">
        <el-link type="primary" @click="handleClick" class="bold-title">
          {{ entity.patientName }}
        </el-link>
        <span class="left-pad">{{ entity.patientGender | dictText("Gender") }}</span>
        <span class="left-pad">{{ entity.patientAge }}</span>
      </el-row>
      <b class="info"> {{ entity.bedNo }} 床 </b>
      <slot name="tools" />
    </el-row>
    <el-descriptions :column="2">
      <template #title>
        <el-link v-if="showDiagnosisLink" type="primary" @click="$emit('diagnosisClick', entity)" style="font-size: 1rem; margin: 0; font-weight: bold">{{ entity.diagnosisName || "待下诊断" }}</el-link>
        <span v-else>{{ entity.diagnosisName || "待下诊断" }}</span>
      </template>
      <el-descriptions-item label="住院号" :span="2">{{ entity.ipNo }}</el-descriptions-item>
      <el-descriptions-item label="入院日期">{{ entity.startDate | fmtDate }}</el-descriptions-item>
      <el-descriptions-item label="入院科室">{{ entity.originalDeptCode | dictText("Dept") }}</el-descriptions-item>
      <el-descriptions-item label="入科日期">{{ entity.checkinDate | fmtDate }}</el-descriptions-item>
      <el-descriptions-item label="在院天数">{{ $utils.Dt.span(entity.startDate, $utils.Dt.now(), "d") }}</el-descriptions-item>
      <el-descriptions-item label="当前科室">{{ entity.deptCode | dictText("Dept") }}</el-descriptions-item>
      <el-descriptions-item label="当前病区">{{ entity.wardCode | dictText("IpWard") }}</el-descriptions-item>
      <el-descriptions-item label="住院医师">{{ entity.doctorName }}</el-descriptions-item>
      <el-descriptions-item label="责任护士">{{ entity.nurseName }}</el-descriptions-item>
      <el-descriptions-item label="主治医师">{{ entity.masterName }}</el-descriptions-item>
      <el-descriptions-item label="主任医师">{{ entity.directorName }}</el-descriptions-item>
      <el-descriptions-item label="预交金剩余" :content-class-name="(entity.balance || 0) <= 0 ? 'danger' : 'success'">
        <el-link v-if="showBalanceLink" :type="(entity.balance || 0) <= 0 ? 'danger' : 'success'" @click="$emit('balanceClick', entity)" >￥{{ (entity.balance || 0) | fmtFloat(2) }}</el-link>
        <span v-else>￥{{ (entity.balance || 0) | fmtFloat(2) }}</span>
      </el-descriptions-item>
    </el-descriptions>
    <el-row type="flex" justify="center">
      <hic-hospitalization-tags :entity="entity" />
    </el-row>
  </el-card>
</template>
<script>
  import { mapGetters } from "sw-hic";
  export default {
    name: "hic-hospitalization-card",
    props: {
      entity: {
        type: Object,
        default: () => {},
      },
      showDiagnosisLink: Boolean,
      showBalanceLink: Boolean,
    },
    components: {
      "hic-hospitalization-tags": () => import("./tags-hospitalization.vue"),
    },
    data() {
      return {};
    },
    computed: {
      ...mapGetters(["Enum"]),
    },
    methods: {
      handleClick() {
        this.$emit("click", this.entity);
      },
    },
  };
</script>
